import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("rvior_cart")) || [];
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("rvior_cart", JSON.stringify(items));
  }, [items]);

  const value = useMemo(() => {
    const add = (item) => {
      setItems((prev) => {
        const key = `${item.productId}|${item.color}|${item.size}`;
        const found = prev.find((p) => `${p.productId}|${p.color}|${p.size}` === key);
        if (found) {
          return prev.map((p) =>
            `${p.productId}|${p.color}|${p.size}` === key ? { ...p, qty: Math.min(p.qty + item.qty, 10) } : p
          );
        }
        return [...prev, { ...item }];
      });
      setOpen(true);
    };
    const updateQty = (idx, qty) =>
      setItems((prev) => prev.map((p, i) => (i === idx ? { ...p, qty: Math.max(1, Math.min(qty, 10)) } : p)));
    const remove = (idx) => setItems((prev) => prev.filter((_, i) => i !== idx));
    const clear = () => setItems([]);
    const subtotal = items.reduce((s, p) => s + p.price * p.qty, 0);
    const count = items.reduce((s, p) => s + p.qty, 0);
    return { items, add, updateQty, remove, clear, subtotal, count, open, setOpen };
  }, [items, open]);

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
}

export function useCart() {
  return useContext(CartContext);
}
